<template>
  <v-container fluid class="down-top-padding tablero">
    <!-- Título -->
    <v-row>
      <v-col style="text-align:center">
        <!-- <v-title>Cuadro de Mando Integral por Curso de Vida</v-title> -->
        <h1 style="color:#2293D7;line-height:35px;">Cuadro de Mando Integral por Curso de Vida</h1>
        <h1 style="color: #B6CE44;line-height:35px;">DIRESA Cajamarca {{ this.anio }} al Mes de {{ this.tituloMes }}</h1>
      </v-col>
    </v-row>
    <!-- Fin Título -->


    <!-- Modal -->
    <div class="row" >
      <v-col cols="12" lg="12">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="900px"
            @click="abrirModal"
            >
            <v-card v-if="datosIndicadorNiño.length > 0">
                <v-card-title class="primary white--text">
                <span class="text-h5">ETAPAS DE VIDA NIÑO</span>
                <v-spacer></v-spacer>
                        <v-btn
                            color="red"
                            dark
                            @click="dialog = false"
                            style="margin-top: -30px;margin-right: -24px;">
                            CERRAR
                        </v-btn>
                </v-card-title>
                <v-card-text>
                <br>                       
                <v-divider></v-divider>
                <v-container>
                  <v-row>
                    <div class="col-md-12">
                        <img src="../assets/images/ninos.png" alt="" style="width: 100%">
                    </div>  
                  </v-row>
                </v-container>
                <v-divider></v-divider>
                <v-container>
                <v-row>
                  <v-col col="12" col-md="2" col-sm="3">
                    <router-link @click.native="getCursoNiñoNeonato()"  v-bind:to="'/cmi/'">
                      Neonato - {{Math.round((this.datosIndicadorNiño[1].NUMERADOR / this.datosIndicadorNiño[1].DENOMINADOR) * 1000)/10}} %
                    </router-link>
                  </v-col>
                  <v-col col="12" col-md="4" col-sm="4">
                    <router-link @click.native="getCursoNiñoMenor1()" v-bind:to="'/cmi/'">
                      Menor de 1 Año - {{Math.round((this.datosIndicadorNiño[2].NUMERADOR / this.datosIndicadorNiño[2].DENOMINADOR) * 1000)/10}} %
                    </router-link>
                  </v-col>
                  <v-col col="12" col-md="3" col-sm="3">
                    <router-link @click.native="getCursoNiño1Año()" v-bind:to="'/cmi/'">
                      1 Año - {{Math.round((this.datosIndicadorNiño[3].NUMERADOR / this.datosIndicadorNiño[3].DENOMINADOR) * 1000)/10}} %
                    </router-link>
                  </v-col>
                  <v-col col="12" col-md="2">
                    <router-link @click.native="getCursoNiño2Años()" v-bind:to="'/cmi/'">
                      2 Años - {{Math.round((this.datosIndicadorNiño[4].NUMERADOR / this.datosIndicadorNiño[4].DENOMINADOR) * 1000)/10}} %
                    </router-link>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col col="12" col-md="2">
                    <router-link @click.native="getCursoNiño3Años()" v-bind:to="'/cmi/'">
                      3 Años - {{Math.round((this.datosIndicadorNiño[5].NUMERADOR / this.datosIndicadorNiño[5].DENOMINADOR) * 1000)/10}} %
                    </router-link>
                  </v-col>
                  <v-col col="12" col-md="2">
                    <router-link @click.native="getCursoNiño4Años()" v-bind:to="'/cmi/'">
                      4 Años - {{Math.round((this.datosIndicadorNiño[6].NUMERADOR / this.datosIndicadorNiño[6].DENOMINADOR) * 1000)/10}} %
                    </router-link>
                  </v-col>
                  <v-col col="12" col-md="4">
                    <router-link @click.native="getCursoNiño511Años()" v-bind:to="'/cmi/'">
                      De 5 a 11 años - {{Math.round((this.datosIndicadorNiño[0].NUMERADOR / this.datosIndicadorNiño[0].DENOMINADOR) * 1000)/10}} %
                    </router-link>
                  </v-col>
                </v-row>
                  
                </v-container>
                <v-divider></v-divider>
                  
                </v-card-text>
                <v-card-actions>
                </v-card-actions>
            </v-card>
            </v-dialog>
      </v-col>
    </div>
    <!-- Fin Modal  -->


    <!-- Espacio -->
    <v-row style="height: 50px;"></v-row>
    <!-- Fin Espacio -->


    <!-- Tablero -->
    <v-row>
      <!-- Paralelogramas Izquierda -->
      <v-col
        xs="12"
        sm="12"
        md="4"  
        lg="4"
        xl="4">
        <!-- Gestante -->
              <div class="paralelogramo-left ov-btn-grow-skew cus-left-one">
                  <v-row>
                    <v-col  lg="3" class="cus-left-one-col-one">
                      <h6 v-if="materno === 'undefined' || materno === null" style="margin: 26% 0% 0% 0%;"><b>Procesando...</b></h6>
                      <h2 v-else style="margin: 26% 0% 0% 0%;"><b v-if="materno.DENOMINADOR > 0">{{Math.round((this.materno.NUMERADOR / this.materno.DENOMINADOR) * 1000)/10}} %</b><b v-else>0 %</b></h2>
                    </v-col>

                    <v-col  lg="4" style="transform: skew(-20deg);text-align: center;">
                      <h6 v-if="materno === 'undefined' || materno === null" style="margin-top:20%; color:#FFF;font-size:1.1rem;"><b><span>Gestante</span></b></h6>
                      <h6 v-else style="margin-top:21%;font-size:1.1rem;"><b><router-link style="color:white" @click.native="getCursoMaterno()" v-bind:to="'/cmi/'">Gestante</router-link></b></h6>
                    </v-col>

                    <v-col  lg="3" style="padding-top: 0px;">
                        <div class="child-paralelogramo-left" style="background: #FFB9D0;">
                            <v-row style="transform: skew(-20deg);text-align: center;">
                                <v-col  lg="12">
                                    <img src="../assets/images/gestante.png" alt="" style="width: 57%;margin: -10% 0% 0% 0;">
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>

                    <v-col  lg="2">
                      <h1 class="number-paralelogramo" style="margin-top:-30%;">1</h1>
                    </v-col>
                  </v-row>
              </div>

          <!-- Niño -->
              <div class="paralelogramo-left ov-btn-grow-skew" style="margin-left: 14%;">
                  <v-row>
                    <v-col  lg="3" style="transform: skew(-20deg);color:#FFF;font-weight: 800;" class="col-3" >
                      <h6 v-if="niño === 'undefined' || niño === null" style="margin: 26% 0% 0% 0%;"><b>Procesando...</b></h6>
                      <h2 v-else style="margin: 26% 0% 0% 0%;"><b v-if="niño.DENOMINADOR > 0">{{Math.round((this.niño.NUMERADOR / this.niño.DENOMINADOR) * 1000)/10}} %</b><b v-else>0 %</b></h2>
                    </v-col>

                    <v-col  lg="4" style="transform: skew(-20deg);text-align: center;">
                      <h6 v-if="niño === 'undefined' || niño === null" style="margin-top:18%; color:#FFF;font-size:1.1rem;"><b><v-btn disabled text dark color="#FFFFFF" style="font-size:1.1rem;" @click="abrirModal">Niño</v-btn></b></h6>
                      <h6 v-else style="margin-top:18%; color:#FFF;font-size:1.1rem;"><b><v-btn text dark color="#FFFFFF" style="font-size:1.1rem;" @click="abrirModal">Niño</v-btn></b></h6>
                    </v-col>

                    <v-col  lg="3" style="padding-top: 0px;">
                        <div class="child-paralelogramo-left">
                            <v-row style="transform: skew(-20deg);text-align: center;">
                                <v-col  lg="12">
                                    <img src="../assets/images/5-11-year.png"  alt="" style="width: 75%;margin: -11% 0% 0% 14%;">
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>

                    <v-col  lg="2">
                      <h1 class="number-paralelogramo" style="margin-top:-30%;">2</h1>
                    </v-col>
                  </v-row>
              </div>
          
          <!-- Adolescente -->
            <div class="paralelogramo-left orange ov-btn-grow-skew" style="margin-left: 23%;">
              <v-row>
                  <v-col  lg="3" style="transform: skew(-20deg);color:#FFF;font-weight: 800;" class="col-3" >
                    <h6 v-if="adolescente === 'undefined' || adolescente === null" style="margin: 26% 0% 0% 0%;"><b>Procesando...</b></h6>
                    <h2 v-else style="margin: 26% 0% 0% 0%;"><b v-if="adolescente.DENOMINADOR > 0">{{Math.round((this.adolescente.NUMERADOR / this.adolescente.DENOMINADOR) * 1000)/10}} %</b><b v-else>0 %</b></h2>
                  </v-col>

                  <v-col  lg="4" style="transform: skew(-20deg);text-align: center;">
                    <h6 v-if="adolescente === 'undefined' || adolescente === null" style="margin-top:20%; color:#FFF;font-size:1.1rem;"><b><span>Adolescente</span></b></h6>
                    <h6 v-else style="margin-top:20%; color:#FFF;font-size:1.1rem;"><b><router-link style="color:white" @click.native="getCursoAdolescente()" v-bind:to="'/cmi/'"><span>Adolescente</span></router-link></b></h6>
                  </v-col>

                  <v-col  lg="3" style="padding-top: 0px;">
                      <div class="child-paralelogramo-left" style="background:#FFA420;">
                          <v-row style="transform: skew(-20deg);text-align: center;">
                              <v-col  lg="12">
                                  <img src="../assets/images/adolescente.png" alt="" style="width: 75%;margin: -9% 0% 0% 15%;">
                              </v-col>
                          </v-row>
                      </div>
                  </v-col>

                  <v-col  lg="2">
                    <h1 class="number-paralelogramo" style="margin-top:-30%;">3</h1>
                  </v-col>
                </v-row>
            </div>

          <!-- Joven -->
          <div class="paralelogramo-left yellow ov-btn-grow-skew" style="margin-left: 32%;">
            <v-row>
                  <v-col  lg="3" style="transform: skew(-20deg);color:#FFF;font-weight: 800;" class="col-3" >
                    <h6 v-if="joven === 'undefined' || joven === null" style="margin: 26% 0% 0% 0%;"><b>Procesando...</b></h6>
                    <h2 v-else style="margin: 26% 0% 0% 0%;"><b v-if="joven.DENOMINADOR > 0">{{Math.round((this.joven.NUMERADOR / this.joven.DENOMINADOR) * 1000)/10}} %</b><b v-else>0 %</b></h2>
                  </v-col>

                  <v-col  lg="4" style="transform: skew(-20deg);text-align: center;">
                    <h6 v-if="joven === 'undefined' || joven === null" style="margin-top:21%; color:#FFF;font-size:1.1rem;"><b><span>Joven</span></b></h6>
                    <h6 v-else style="margin-top:21%; color:#FFF;font-size:1.1rem;"><b><router-link style="color:white" @click.native="getCursoJoven()" v-bind:to="'/cmi'"><span>Joven</span></router-link></b></h6>
                  </v-col>

                  <v-col  lg="3" style="padding-top: 0px;">
                      <div class="child-paralelogramo-left"  style="background:#FFE740;">
                          <v-row style="transform: skew(-20deg);text-align: center;">
                              <v-col  lg="12">
                                  <img src="../assets/images/joven.png" alt="" style="width: 84%;margin: -4% 0% 0% 10%;">
                              </v-col>
                          </v-row>
                      </div>
                  </v-col>

                  <v-col  lg="2">
                    <h1 class="number-paralelogramo" style="margin-top:-30%;">4</h1>
                  </v-col>
              </v-row>
          </div>
      </v-col>
      <!-- Fin Paralelogramas Izquierda -->

      <!-- Trapecios (Centro) -->
      <v-col
        xs="12"
        sm="12"
        md="4"  
        lg="4"
        xl="4">
        <v-row>
          <v-col lg="12">
              <v-row  class="trapecio-top-new">
                <v-col lg="12" style="margin-top:-230px; padding-left:10%">
                  <v-img src="../assets/images/Logo DIRESA-2.png" max-width="200"></v-img>
                </v-col>
              </v-row>

              <v-row class="trapecio-top-two-new">
              <v-col lg="12"  style="margin-top:-130px;margin-left:21%" >
                <h6 style="font-size:1.1rem;">
                <b><router-link style="color:#991544" v-bind:to="'/cmi/'">Inicio</router-link></b>
                  <br>
                  <v-icon
                  large
                  color="#991544"
                  >
                  mdi-home
                </v-icon>
                </h6>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!-- Fin Trapecio (Centro) -->

      <!-- Paralelogramas Derecha -->
      <v-col
        xs="12"
        sm="12"
        md="4"  
        lg="4"
        xl="4">
        <!-- Adulto -->
        <div class="paralelogramo-right ov-btn-grow-skew" style="background: #B6CE44; margin-left: 4%;">
          <v-row>
            <v-col lg="2" style="text-align: center; padding-left:5%; margin-top:-3%;">
              <h1 class="number-paralelogramo">5</h1>
            </v-col>
            <v-col lg="3" style="padding-top: 0px;">
              <div class="child-paralelogramo-right" style="background: #D7E181;">
                <v-row style="transform: skew(20deg);text-align: center;">
                  <v-col lg="12">
                    <img src="../assets/images/adulto.png" alt="" style="width: 80%;margin: 0% 0% 0% -5%;">
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col lg="4" style="transform: skew(20deg);text-align: center;">
              <h6 v-if="adulto === 'undefined' || adulto === null" style="margin-top:20%; color:#FFF;font-size:1.1rem;"><b><span>Adulto</span></b></h6>
              <h6 v-else style="margin-top:20%; color:#FFF;font-size:1.1rem;"><b><router-link style="color:white" @click.native="getCursoAdulto()" v-bind:to="'/cmi'"><span>Adulto</span></router-link></b></h6>
            </v-col>
            <v-col lg="3" style="transform: skew(20deg);color:#FFF;font-weight: 800;">
              <h6 v-if="adulto === 'undefined' || adulto === null" style="margin: 26% 0% 0% 0%;"><b>Procesando...</b></h6>
              <h2 v-else style="margin: 26% 0% 0% 0%;"><b v-if="this.adulto.DENOMINADOR > 0">{{Math.round((this.adulto.NUMERADOR / this.adulto.DENOMINADOR) * 1000)/10}} %</b><b v-else>0 %</b></h2>
            </v-col>
          </v-row>
        </div>
          
          <!-- Adulto mayor -->
          <div class="paralelogramo-right lightseagreen ov-btn-grow-skew" style="margin-left: -5%;">
            <v-row>
              <v-col lg="2" style="text-align: center; padding-left:5%; margin-top:-4%;">
                <h1 class="number-paralelogramo">6</h1>
              </v-col>
              <v-col lg="3" style="padding-top: 0px;">
                <div class="child-paralelogramo-right" style="background: #1A8E88;height: 87%;">
                  <v-row style="transform: skew(20deg);text-align: center;">
                    <v-col lg="12">
                      <img src="../assets/images/adulto-mayor.png" alt="" style="width: 100%;margin: 3% 0% 0% -5%;">
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col lg="4" style="transform: skew(20deg);text-align: center;">
                <h6 v-if="adulto_mayor === 'undefined' || adulto_mayor === null" style="margin-top:18%; color:#FFF;font-size:1.1rem;"><b><span>Adulto Mayor</span></b></h6>
                <h6 v-else style="margin-top:18%; color:#FFF;font-size:1.1rem;"><b><router-link style="color:white" @click.native="getCursoAdultoMayor()" v-bind:to="'/cmi'"><span>Adulto Mayor</span></router-link></b></h6>
              </v-col>
              <v-col lg="3" style="transform: skew(20deg);color:#FFF;font-weight: 800;">
                <h6 v-if="adulto_mayor === 'undefined' || adulto_mayor === null" style="margin: 20% 0% 0% 0%;"><b>Procesando...</b></h6>
                <h2 v-else style="margin: 20% 0% 0% 0%;"><b v-if="adulto_mayor.DENOMINADOR > 0">{{Math.round((this.adulto_mayor.NUMERADOR / this.adulto_mayor.DENOMINADOR) * 1000)/10}} %</b><b v-else>0 %</b></h2>
              </v-col>
            </v-row>
          </div>

          <!-- Medicamentos -->
          <div class="paralelogramo-right ov-btn-grow-skew" style="margin-left: -13%;background: #D50C52;">
            <v-row>
              <v-col lg="2" style="text-align: center; padding-left:5%; margin-top:-3%;">
                <h1 class="number-paralelogramo">7</h1>
              </v-col>
              <v-col lg="3" style="padding-top: 0px;">
                <div class="child-paralelogramo-right" style="background:#991544;">
                  <v-row style="transform: skew(20deg);text-align: center;">
                    <v-col lg="12">
                      <img src="../assets/images/medicamentos.png" alt="" style="width: 75%;margin: 15% 0% 0% -15%;">
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col lg="4" style="transform: skew(20deg);text-align: center;">
                <h6 style="margin-top:20%; color:#FFF;font-size:1.1rem;"><b><router-link style="color:#FFFFFF" v-bind:to="'/medicamentos'">Medicamentos</router-link></b></h6>
              </v-col>
              <v-col lg="3" style="transform: skew(20deg);color:#FFF;font-weight: 800;">
                <h2 style="margin: 20% 0% 0% 0%;"></h2>
              </v-col>
            </v-row>
          </div>
          
          <!-- Joven -->
          <div class="paralelogramo-right coffe ov-btn-grow-skew" style="margin-left: -21%;">
              <v-row>
                <v-col lg="2" style="text-align: center; padding-left:5%; margin-top:-3%;">
                  <h1 class="number-paralelogramo">8</h1>
                </v-col>
                <v-col lg="3" style="padding-top: 0px;">
                  <div class="child-paralelogramo-right" style="background:#B9A28B;">
                    <v-row style="transform: skew(20deg);text-align: center;">
                      <v-col lg="12">
                        <img src="../assets/images/5-11-year.png" alt="" style="width: 70%;margin: -10% 0% 0% 0%;">
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col lg="4" style="transform: skew(20deg);text-align: center;">
                  <h6 style="margin-top:10%;font-size:1.1rem;"><b><router-link style="color:white" v-bind:to="'/seguimiento'">Seguimiento Nominal</router-link></b></h6>
                </v-col>
                <v-col lg="3" style="transform: skew(20deg);color:#FFF;font-weight: 800;">
                  <h2 style="margin: 20% 0% 0% 0%;"></h2>
                </v-col>
              </v-row>
          </div>
      </v-col>
      <!-- Fin Paralelogramas derecha -->
    </v-row>
    <!-- Fin Tablero -->
  </v-container>
</template>

<script>

import axios from 'axios';

export default {
  name: "StarterPage",
  data: () => ({
    page: {
      title: "StarterPage"
    },
    dialog: false,
    fechaActual: new Date(),
    mesActual: 1,
    mesActual1: 1,
    mes: [],
    anio: 2022,
    datosIndicador: [],
    datosIndicadorNiño: [],
    tituloMes: '',
    materno: null,
    niño: null,
    adolescente: null,
    joven: null,
    adulto: null,
    adulto_mayor: null,
    meses: [
      {
        Id: 1,
        Nombre: 'Enero'
      },
      {
        Id: 2,
        Nombre: 'Febrero'
      },
      {
        Id: 3,
        Nombre: 'Marzo'
      },
      {
        Id: 4,
        Nombre: 'Abril'
      },
      {
        Id: 5,
        Nombre: 'Mayo'
      },
      {
        Id: 6,
        Nombre: 'Junio'
      },
      {
        Id: 7,
        Nombre: 'Julio'
      },
      {
        Id: 8,
        Nombre: 'Agosto'
      },
      {
        Id: 9,
        Nombre: 'Septiembre'
      },
      {
        Id: 10,
        Nombre: 'Octubre'
      },
      {
        Id: 11,
        Nombre: 'Noviembre'
      },
      {
        Id: 12,
        Nombre: 'Diciembre'
      }
    ],
  }),
  components:{
  },
  created() {
    this.getAnio()
  },
  methods: {
    async getAnio(){
        await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/cargas/AnioMax')
        .then(response => {
          this.anio = response.data
          this.getMes()
        })
    },
    async getMes(){
        await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/cargas/MesMax/'+this.anio).then(response => {
          this.mesActual = response.data 
          this.mes = response.data;
          this.mesActual = this.mes - 1
          this.tituloMes = this.meses[this.mesActual].Nombre;
          this.getIndicadores()
          this.getIndicadoresNiño()
        })
    },
    abrirModal(){
      this.dialog = true
    },
    async getIndicadores(){
      this.overlay = true
        await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/indicadoresPaquete',{
            params: {
                mes: this.mes,
            }
        }).then(response => {
            this.datosIndicador = response.data
            if(typeof this.datosIndicador.find(obj => obj.ID_ACTIVIDAD === '17') !== 'undefined'){
              this.materno = this.datosIndicador.find(obj => obj.ID_ACTIVIDAD === '17')
            }
            if(typeof this.datosIndicador.find(obj => obj.ID_ACTIVIDAD === '226') !== 'undefined'){
              this.niño = this.datosIndicador.find(obj => obj.ID_ACTIVIDAD === '226')
            }
            if(typeof this.datosIndicador.find(obj => obj.ID_ACTIVIDAD === '318') !== 'undefined'){
              this.adolescente = this.datosIndicador.find(obj => obj.ID_ACTIVIDAD === '318')
            }
            if(typeof this.datosIndicador.find(obj => obj.ID_ACTIVIDAD === '415') !== 'undefined'){
              this.joven = this.datosIndicador.find(obj => obj.ID_ACTIVIDAD === '415')
            }
            if(typeof this.datosIndicador.find(obj => obj.ID_ACTIVIDAD === '617') !== 'undefined'){
              this.adulto = this.datosIndicador.find(obj => obj.ID_ACTIVIDAD === '617')
            }
            if(typeof this.datosIndicador.find(obj => obj.ID_ACTIVIDAD === '616') !== 'undefined'){
              this.adulto_mayor = this.datosIndicador.find(obj => obj.ID_ACTIVIDAD === '616')
            }
        })
      this.overlay = false
    },
    async getIndicadoresNiño(){
      this.overlay = true
        await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/indicadoresPaqueteNiño',{
            params: {
                mes: this.mes,
            }
        }).then(response => {
            this.datosIndicadorNiño = response.data
        })
        this.overlay = false
    },
    getCursoMaterno(){
      this.$store.state.curso = 1
    },
    getCursoNiñoNeonato(){
      this.$store.state.curso = 2
      this.$store.state.grupo = 0
    },
    getCursoNiñoMenor1(){
      this.$store.state.curso = 2
      this.$store.state.grupo = 1
    },
    getCursoNiño1Año(){
      this.$store.state.curso = 2
      this.$store.state.grupo = 2
    },
    getCursoNiño2Años(){
      this.$store.state.curso = 2
      this.$store.state.grupo = 3
    },
    getCursoNiño3Años(){
      this.$store.state.curso = 2
      this.$store.state.grupo = 4
    },
    getCursoNiño4Años(){
      this.$store.state.curso = 2
      this.$store.state.grupo = 5
    },
    getCursoNiño511Años(){
      this.$store.state.curso = 2
      this.$store.state.grupo = 6
    },
    getCursoNiñoMenor36Meses(){
      this.$store.state.curso = 2
      this.$store.state.grupo = 7
    },
    getCursoAdolescente(){
      this.$store.state.curso = 3
    },
    getCursoJoven(){
      this.$store.state.curso = 4
    },
    getCursoAdulto(){
      this.$store.state.curso = 5
    },
    getCursoAdultoMayor(){
      this.$store.state.curso = 6
    },
    updateMeses(){
      this.getIndicadores()
      if(this.mes.length > 1){
        this.mes.forEach(function(m) {
          if(this.mesActual < m){
            this.mesActual = m
          }
        }, this);
      }
      this.tituloMes = this.meses[12].Nombre;
    },
  }
};
</script>

<style scoped>

  a:link, a:visited,  a:hover, a:active
{
    color: #000000;
    text-decoration: none;
}
.tablero{
    margin-top:15px;
    max-width:1400px;
}

.div-center{
    text-align: center;
}

/* .pt-30{
    padding-top: 30px;
} */

.paralelogramo-left {
    width: 90%; 
    height: 15%; 
    /* border: 3px solid #555;  */
    background: #1D98D6;
    -webkit-transform: skew(20deg);
    -moz-transform: skew(20deg);
    -ms-transform: skew(20deg);
    -o-transform: skew(20deg);
    transform: skew(20deg);
    margin: 0% 0% 4% 20%;
    box-shadow: 3px 3px 3px 2px rgba(0, 0, 0, 0.2);
}

.paralelogramo-right {
    width: 90%; 
    height: 15%;
    /* border: 3px solid #555;  */
    background: #1D98D6;
    -webkit-transform: skew(20deg);
    -moz-transform: skew(20deg);
    -ms-transform: skew(20deg);
    -o-transform: skew(20deg);
    transform: skew(-20deg);
    margin: 0% 10% 4% -25%;
    box-shadow: 3px 3px 3px 2px rgba(0, 0, 0, 0.2);
}

.light-blue{
    background: #2293D7;
}
.light-blue-two{
    background: #1D98D6;
}

.green{
    background: #B6CE44;
}

.orange{
    background: #FF8000;
}

.red{
    background: #D50C52;
}

.yellow{
    background: #FFD700;
}

.coffe{
    background: #A18262;
}
.pink{
    background: #EA899A;
}
.gray{
    background: #C6C6C6;
}
.lightseagreen{
    background: #20B2AA;
}

/* .paralelogramo-right:hover{
    background: rgb(255, 255, 255, 0.3);
} */

.child-paralelogramo-left {
    width: 100%; 
    height: 77%; 
    /* border: 3px solid #555;  */
    background: #3CBEE1;
    -webkit-transform: skew(20deg);
    -moz-transform: skew(20deg);
    -ms-transform: skew(20deg);
    -o-transform: skew(20deg);
    transform: skew(1deg);
    margin: 0px 0px 15px 0px;
    box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
}
.child-paralelogramo-right {
    width: 100%; 
    height: 77%; 
    /* border: 3px solid #555;  */
    background: #3CBEE1;
    -webkit-transform: skew(20deg);
    -moz-transform: skew(20deg);
    -ms-transform: skew(20deg);
    -o-transform: skew(20deg);
    transform: skew(1deg);
    margin: 0px 0px 15px 0px;
    box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
}
.number-paralelogramo{
    padding-top:40%;
    font-weight:900;
    font-size: 3.2rem;
    color: rgb(255, 255, 255, 0.3);
}
.trapecio-top {
    width: 90%;
    height: 0px;
    border-right: 80px solid transparent;
    border-left: 80px solid transparent;
    border-top: 250px solid #1687AF;
    margin:0px 0px 15px 18px;
    /* margin: 0px 0px 15px 0px; */
}

.trapecio-top-two {
    width: 52%;
    height: 0px;
    border-right: 45px solid transparent;
    border-left: 45px solid transparent;
    border-top: 200px solid #FF4FAE;
    margin:0px 0px 15px 100px;
    /* margin: 0px 0px 15px 0px; */
}

.trapecio-top-three {
  width: 30%;
  height: 0px;
  border-right: 35px solid transparent;
  border-left: 35px solid transparent;
  border-top: 130px solid #C6C6C6;
  margin:0px 0px 15px 150px;
  /* margin: 0px 0px 15px 0px; */
}

/* Para nuevo diseño */
.trapecio-top-new {
  width: 90%;
  /* height: 0px; */
  border-right: 70px solid transparent;
  border-left: 70px solid transparent;
  border-top: 230px solid #1687AF;
  margin:-3% 0% 0% 5%;
  /* margin: 0px 0px 15px 0px; */
}

.trapecio-top-two-new {
  width: 55%;
  /* height: 0px; */
  border-right: 60px solid transparent;
  border-left: 60px solid transparent;
  border-top: 160px solid #C6C6C6;
  margin: 5% 0% 0% 22%;
  /* margin: 0px 0px 15px 0px; */
}

.ov-btn-grow-trapecio-new:hover {
  color: #fff;/* color de fuente hover */
}
.ov-btn-grow-trapecio-new::after {
  content: "";
  position: absolute;
  z-index: 2;
  display: block;
  transform: scale(0, 0);
  transition: all 0.3s ease;
  top: 21%;
  left: 39%;
  width: 22%;
  border-right: 70px solid transparent;
  border-left: 70px solid transparent;
  border-top: 210px solid rgb(0, 0, 0, 0.1);
  /* margin:0px 0px 0px 0px; */
}
.ov-btn-grow-trapecio-new:hover::after {
  transition: all 0.3s ease-out;
  transform: scale(1, 1);
}

.ov-btn-grow-trapecio-two-new:hover {
  color: #fff;/* color de fuente hover */
}
.ov-btn-grow-trapecio-two-new::after {
  content: "";
  position: absolute;
  z-index: 2;
  display: block;
  transform: scale(0, 0);
  transition: all 0.3s ease;
  top: 54%;
  left: 42%;
  width: 14%;
  border-right: 60px solid transparent;
  border-left: 60px solid transparent;
  border-top: 160px solid rgb(0, 0, 0, 0.1);
  /* margin:0px 0px 0px 0px; */
}
.ov-btn-grow-trapecio-two-new:hover::after {
  transition: all 0.3s ease-out;
  transform: scale(1, 1);
}

/* End para nuevo diseño */

.ov-btn-grow-skew:hover {
    color: #fff;/* color de fuente hover */
  }
  .ov-btn-grow-skew::after {
    content: "";
    background: rgb(0, 0, 0, 0.1); /* color de fondo hover */
    position: absolute;
    z-index: -1;
    padding: 16px 20px;
    display: block;
    left: -0%;
    right: -0%;
    top: 0;
    bottom: 0;
    transform: skewX(0deg) scale(0, 1);
    transition: all 0.3s ease;
  }
  .ov-btn-grow-skew:hover::after {
    transition: all 0.3s ease-out;
    transform: skewX(0deg) scale(1, 1);
  }


  .ov-btn-grow-trapecio:hover {
    color: #fff;/* color de fuente hover */
  }
  .ov-btn-grow-trapecio::after {
    content: "";
    position: absolute;
    z-index: 2;
    display: block;
    transform: scale(0, 0);
    transition: all 0.3s ease;
    top: 4%;
    left: 7%;
    width: 84%;
    border-right: 80px solid transparent;
    border-left: 80px solid transparent;
    border-top: 250px solid rgb(0, 0, 0, 0.1);
    /* margin:0px 0px 0px 0px; */
  }
  .ov-btn-grow-trapecio:hover::after {
    transition: all 0.3s ease-out;
    transform: scale(1, 1);
  }




  .ov-btn-grow-trapecio-two:hover {
    color: #fff;/* color de fuente hover */
  }
  .ov-btn-grow-trapecio-two::after {
    content: "";
    position: absolute;
    z-index: 2;
    display: block;
    transform: scale(0, 0);
    transition: all 0.3s ease;
    top: 41%;
    left: 25%;
    width: 48%;
    border-right: 45px solid transparent;
    border-left: 45px solid transparent;
    border-top: 150px solid rgb(0, 0, 0, 0.1);
    /* margin:0px 0px 0px 0px; */
  }
  .ov-btn-grow-trapecio-two:hover::after {
    transition: all 0.3s ease-out;
    transform: scale(1, 1);
  }



  .ov-btn-grow-trapecio-three:hover {
    color: #fff;/* color de fuente hover */
  }
  .ov-btn-grow-trapecio-three::after {
    content: "";
    position: absolute;
    z-index: 2;
    display: block;
    transform: scale(0, 0);
    transition: all 0.3s ease;
    top: 64%;
    left: 35%;
    width: 29%;
    border-right: 40px solid transparent;
    border-left: 40px solid transparent;
    border-top: 130px solid rgb(0, 0, 0, 0.1);
    /* margin:0px 0px 0px 0px; */
  }
  .ov-btn-grow-trapecio-three:hover::after {
    transition: all 0.3s ease-out;
    transform: scale(1, 1);
  }

  /* RIGHT ARROW */
.arrowRight{
 position:relative;
 margin: 20px;
 width:48px;
 height: 38px;
 background: #d1d1d1;
 border:solid 1px #999;
 float: left;
}

 .arrowRight:before, .arrowRight:after {
 border-bottom: 20px solid transparent;
 border-top: 20px solid transparent;
 top:-1px;
 content: " ";
 position: absolute;
 display: block;
 width: 0;
 height: 0;   
 }
 .arrowRight:after {
 border-left: 16px solid #d1d1d1;
 right: -15px;
 z-index: 2;
 }
 
.arrowRight:before {
 border-left: 16px solid #999;
 right: -16px;
 z-index: 1;
 }

 .cus-left-one{
  background: #EA899A; 
  margin-left: 5%;
 }
 .cus-left-one-col-one{
  transform: skew(-20deg);
  color:#FFF;
  font-weight: 800;
 }

 @media only screen and (min-width: 576px) and (max-width: 767px), only screen and (min-width: 992px) and (max-width: 1199px), only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .tablero{
    margin-top:0px;
    max-width:100%;
}

.trapecio-top-new {
  visibility: hidden ;
}

.trapecio-top-two-new {
  display:none;
  /* visibility: hidden ; */
}
.paralelogramo-left {
    width: 100%; 
    height: 15%; 
    /* border: 3px solid #555;  */
    background: #1D98D6;
    -webkit-transform: none;
    -moz-transform: none;
    -ms-transform: none;
    -o-transform: none;
    transform: none;
    margin: 0% 0% 4% 20%;
    box-shadow: 3px 3px 3px 2px rgba(0, 0, 0, 0.2);
}

.paralelogramo-right {
    width: 100%; 
    height: 15%;
    /* border: 3px solid #555;  */
    background: #1D98D6;
    -webkit-transform: none;
    -moz-transform: none;
    -ms-transform: none;
    -o-transform: none;
    transform: none;
    margin: 0% 10% 4% -25%;
    box-shadow: 3px 3px 3px 2px rgba(0, 0, 0, 0.2);
}
.cus-left-one{
  background: #EA899A; 
  margin-left: 0;
}
.cus-left-one-col-one{
  color:#FFF;
  font-weight: 800;
}

}
</style>